module.exports = __webpack_public_path__ + "ff01c4928a2c1000b9f7b66fdb7645f7.svg";